import { Trophy, Users, Calendar, BarChart3, Shield, Zap } from 'lucide-react'

export default function FeaturesSection() {
  const features = [
    {
      icon: Trophy,
      title: "Quản lý Giải đấu",
      description: "Tạo và quản lý các giải đấu với hệ thống bảng đấu tự động và theo dõi kết quả real-time",
      color: "yellow",
      stats: "50+ giải đấu"
    },
    {
      icon: Users,
      title: "Quản lý Thành viên",
      description: "Đăng ký, phân loại và theo dõi thông tin chi tiết của tất cả thành viên tham gia",
      color: "green",
      stats: "500+ thành viên"
    },
    {
      icon: Calendar,
      title: "Lịch thi đấu",
      description: "Lập lịch thi đấu thông minh với thông báo real-time cho tất cả người tham gia",
      color: "blue",
      stats: "24/7 cập nhật"
    },
    {
      icon: BarChart3,
      title: "Thống kê & Báo cáo",
      description: "Phân tích hiệu suất chi tiết với biểu đồ và báo cáo chuyên nghiệp",
      color: "purple",
      stats: "Real-time data"
    },
    {
      icon: Shield,
      title: "Bảo mật Cao",
      description: "Hệ thống bảo mật đa lớp đảm bảo an toàn thông tin và dữ liệu người dùng",
      color: "red",
      stats: "99.9% uptime"
    },
    {
      icon: Zap,
      title: "Hiệu suất Cao",
      description: "Xử lý nhanh chóng với công nghệ cloud hiện đại và tối ưu hóa",
      color: "orange",
      stats: "<100ms response"
    }
  ]

// Removed unused highlights array to resolve TS6133
  const getColorClasses = (color: string, type: 'bg' | 'icon' | 'text' | 'badge') => {
    const colorMap = {
      yellow: {
        bg: 'absolute inset-0 bg-gradient-to-br from-mebi-yellow-50 to-mebi-yellow-100/50 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300',
        icon: 'w-16 h-16 bg-gradient-to-br from-mebi-yellow-500 to-mebi-yellow-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300',
        text: 'text-sm font-medium text-mebi-yellow-700',
        badge: 'inline-flex items-center px-3 py-1 bg-mebi-yellow-100 rounded-full'
      },
      green: {
        bg: 'absolute inset-0 bg-gradient-to-br from-mebi-green-50 to-mebi-green-100/50 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300',
        icon: 'w-16 h-16 bg-gradient-to-br from-mebi-green-500 to-mebi-green-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300',
        text: 'text-sm font-medium text-mebi-green-700',
        badge: 'inline-flex items-center px-3 py-1 bg-mebi-green-100 rounded-full'
      },
      blue: {
        bg: 'absolute inset-0 bg-gradient-to-br from-mebi-blue-50 to-mebi-blue-100/50 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300',
        icon: 'w-16 h-16 bg-gradient-to-br from-mebi-blue-500 to-mebi-blue-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300',
        text: 'text-sm font-medium text-mebi-blue-700',
        badge: 'inline-flex items-center px-3 py-1 bg-mebi-blue-100 rounded-full'
      },
      purple: {
        bg: 'absolute inset-0 bg-gradient-to-br from-mebi-purple-50 to-mebi-purple-100/50 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300',
        icon: 'w-16 h-16 bg-gradient-to-br from-mebi-purple-500 to-mebi-purple-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300',
        text: 'text-sm font-medium text-mebi-purple-700',
        badge: 'inline-flex items-center px-3 py-1 bg-mebi-purple-100 rounded-full'
      },
      red: {
        bg: 'absolute inset-0 bg-gradient-to-br from-mebi-red-50 to-mebi-red-100/50 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300',
        icon: 'w-16 h-16 bg-gradient-to-br from-mebi-red-500 to-mebi-red-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300',
        text: 'text-sm font-medium text-mebi-red-700',
        badge: 'inline-flex items-center px-3 py-1 bg-mebi-red-100 rounded-full'
      },
      orange: {
        bg: 'absolute inset-0 bg-gradient-to-br from-mebi-orange-50 to-mebi-orange-100/50 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300',
        icon: 'w-16 h-16 bg-gradient-to-br from-mebi-orange-500 to-mebi-orange-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300',
        text: 'text-sm font-medium text-mebi-orange-700',
        badge: 'inline-flex items-center px-3 py-1 bg-mebi-orange-100 rounded-full'
      }
    }
    return colorMap[color as keyof typeof colorMap]?.[type] || colorMap.yellow[type]
  }

  return (
    <section className="py-20 bg-gradient-to-b from-neutral-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-neutral-900 mb-4">
              Các tính năng chính
            </h2>
            <p className="text-lg text-neutral-600 max-w-3xl mx-auto">
              Các module cốt lõi để tổ chức và vận hành giải đấu hiệu quả.
            </p>
          </div>

          {/* Main Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
            {features.map((feature, index) => {
              const IconComponent = feature.icon
              return (
                <div 
                  key={index}
                  className="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 border border-white/20 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                >
                  {/* Background Gradient */}
                  <div className={getColorClasses(feature.color, 'bg')} />
                  
                  {/* Content */}
                  <div className="relative z-10">
                    {/* Icon */}
                    <div className={getColorClasses(feature.color, 'icon')}>
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>

                    {/* Title & Description */}
                    <h3 className="text-xl font-bold text-neutral-900 mb-3 group-hover:text-neutral-800">
                      {feature.title}
                    </h3>
                    <p className="text-neutral-600 mb-4 leading-relaxed">
                      {feature.description}
                    </p>


                  </div>
                </div>
              )
            })}
          </div>




        </div>
      </div>
    </section>
  )
}